import React from 'react'

export default function PrivacyPolicy() {
  return (
    <div className="container my-5 bg-white">
      <h1>Privacy Policy for Membotic</h1>
      <p><strong>Effective Date:</strong> 7 February 2025</p>
      <p>At Membotic, we value your privacy and are committed to being transparent about how we handle your personal data. This Privacy Policy explains what personal data we collect, why we collect it, how we use it, and your rights regarding your information.</p>

      <h2>1. Contact Details</h2>
      <p>If you have any questions about this Privacy Policy or how we use your personal data, you can contact us at:</p>
      <p><strong>Membotic</strong></p>
      <p>Email: <a href="mailto:info@membotic.com">info@membotic.com</a></p>
      <p>Address: 86-90 Paul Street, London, EC2A 4NE</p>

      <h2>2. The Types of Personal Data We Collect</h2>
      <p>We collect various types of personal data, including:</p>
      <ul>
        <li><strong>Identification Information:</strong> Name, username, email address, phone number, and account details.</li>
        <li><strong>Payment Information:</strong> Payment details for transactions made through the app, processed via third-party payment providers.</li>
        <li><strong>Location Data:</strong> If you have enabled location-based services, we may collect location information.</li>
        <li><strong>Usage Data:</strong> This includes data such as your device type, IP address, browser type, and app usage patterns.</li>
      </ul>

      <h2>3. Where We Got Your Data From</h2>
      <p>We collect your data directly from you when you register, use the app, or make purchases. We may also receive information from third-party services such as payment processors, social media accounts (if linked), or other integrations that you use in connection with the app.</p>

      <h2>4. Why We Have Your Information and What We Do with It</h2>
      <p>We collect and use your personal data for the following purposes:</p>
      <ul>
        <li>To provide and improve the services within the app.</li>
        <li>To process transactions and manage payments.</li>
        <li>To personalize your experience and send relevant notifications or marketing communications.</li>
        <li>To respond to customer support requests and feedback.</li>
        <li>To ensure compliance with legal obligations and to prevent fraud or misuse of the app.</li>
      </ul>

      <h2>5. Your Lawful Basis for Processing Your Data</h2>
      <p>We rely on the following lawful bases for processing your personal data:</p>
      <ul>
        <li><strong>Consent:</strong> When you give us permission to use your data, such as agreeing to receive marketing communications.</li>
        <li><strong>Contractual Necessity:</strong> We process your data to fulfill contracts, such as processing payments and providing the services you request.</li>
        <li><strong>Legitimate Interests:</strong> We process data for our legitimate business interests, such as improving our services, ensuring security, and preventing misuse.</li>
      </ul>

      <h2>6. Who We Share Your Information With</h2>
      <p>We share your personal data only with the following third parties:</p>
      <ul>
        <li><strong>Stripe:</strong> For processing payments securely. Stripe handles your payment information according to its own privacy policy.</li>
        <li><strong>Twilio:</strong> For sending communication notifications, such as emails. Twilio handles your information and communication details according to its own privacy policy.</li>
      </ul>
      <p>We may share your personal data with other third parties in the following situations:</p>
      <ul>
        <li><strong>Legal Compliance:</strong> We may disclose your data to comply with legal obligations or protect our rights.</li>
        <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred to the new owner.</li>
      </ul>

      <h2>7. How Long We Hold Your Information For</h2>
      <p>We retain your personal data for as long as necessary to fulfil the purposes outlined in this Privacy Policy, including legal, accounting, or reporting requirements. When no longer needed, we securely delete or anonymize your data.</p>

      <h2>8. Data Protection Regulation</h2>
      <p>We are committed to ensuring that your personal data is processed in compliance with applicable data protection laws. As a UK-based business, we are governed by:</p>
      <ul>
        <li><strong>General Data Protection Regulation (GDPR):</strong> As applicable in the UK.</li>
        <li><strong>Data Protection Act 2018 (UK):</strong> Which incorporates the GDPR into UK law.</li>
      </ul>
      <p>These regulations provide you with specific rights regarding your personal data, including the right to:</p>
      <ul>
        <li>Access your personal data</li>
        <li>Rectify or update your personal data</li>
        <li>Request the deletion of your personal data (right to be forgotten)</li>
        <li>Object to or restrict the processing of your personal data</li>
        <li>Withdraw consent where processing is based on consent</li>
        <li>Port your data to another service provider in a machine-readable format (data portability)</li>
      </ul>
      <p>If you believe that your personal data has been processed in a way that does not comply with these regulations, you have the right to lodge a complaint with the UK Information Commissioner’s Office (ICO).</p>
      <p>For more information about your rights or to exercise them, please contact us using the details provided above.</p>
    </div>
  );
}
